import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    loginRealizado: false,
    notificado: false,
  },
  reducers: {
    loginReduced: (state) => {
      state.loginRealizado = true;
    },

    notificado: (state) => {
      state.notificado = true;
    },
  },
});

export const { loginReduced } = authSlice.actions;

export default authSlice.reducer;
